import React, { useState, useEffect } from "react";
import { Request } from "../../hooks/Request";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";
import { useDialog } from "../../contexts/DialogContext";

const listFields = [/*"registroDePerdida",*/ "registroDeReclamos"];

const ReclamoCard = ({ item, idx, updateReclamo, removeReclamo }) => {
  const [newHistorial, setNewHistorial] = useState({ fecha: "", detalle: "" });

  const addHistorial = () => {
    if (!newHistorial.fecha || !newHistorial.detalle) return;
    const updatedHistorial = [...(item.historial || []), newHistorial];
    updateReclamo(idx, "historial", updatedHistorial);
    setNewHistorial({ fecha: "", detalle: "" });
  };

  const removeHistorial = (hIdx) => {
    const updatedHistorial = item.historial.filter((_, i) => i !== hIdx);
    updateReclamo(idx, "historial", updatedHistorial);
  };

  return (
    <div className="border border-gray-300 rounded-xl p-5 bg-white shadow-sm flex flex-col gap-4 relative mt-2">
      <div className="flex justify-between items-start gap-4">
        <div className="flex-1">
          <h4 className="font-bold text-gray-800 text-sm mb-1">
            Descripción y Causa:
          </h4>
          <p className="text-gray-700 text-sm bg-gray-50 p-3 border border-gray-200 rounded-lg min-h-[40px] whitespace-pre-wrap">
            {item.descripcion}
          </p>
        </div>
        <button
          onClick={() => removeReclamo(idx)}
          className="text-red-400 hover:text-red-600 hover:bg-red-50 p-2 rounded-full transition-colors flex-shrink-0 mt-5"
          title="Eliminar reclamo completo"
        >
          <i className="fas fa-trash-alt text-lg"></i>
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4 bg-gray-50 p-3.5 rounded-lg border border-gray-200">
        <div>
          <span className="block text-[11px] font-bold text-gray-500 mb-1 uppercase tracking-wider">
            Fecha Detección
          </span>
          <span className="text-sm font-medium text-gray-800">
            {item.fechaDeteccion || "-"}
          </span>
        </div>
        <div>
          <span className="block text-[11px] font-bold text-gray-500 mb-1 uppercase tracking-wider">
            Quién Detectó
          </span>
          <span className="text-sm font-medium text-gray-800">
            {item.quienDetecta || "-"}
          </span>
        </div>
        <div>
          <span className="block text-[11px] font-bold text-gray-500 mb-1 uppercase tracking-wider">
            Fecha Reclamo
          </span>
          <span className="text-sm font-medium text-gray-800">
            {item.fechaReclamo || "-"}
          </span>
        </div>
        <div>
          <span className="block text-[11px] font-bold text-gray-500 mb-1 uppercase tracking-wider">
            Estado Global
          </span>
          <select
            value={item.estado}
            onChange={(e) => updateReclamo(idx, "estado", e.target.value)}
            className={`w-full text-sm border-gray-300 rounded p-1.5 font-semibold outline-none focus:ring-1 focus:ring-blue-500 ${item.estado === "Cerrado" ? "bg-green-100 text-green-800 border-green-200" : item.estado === "En proceso" ? "bg-yellow-100 text-yellow-800 border-yellow-200" : "bg-blue-100 text-blue-800 border-blue-200"}`}
          >
            <option value="Abierto">Abierto</option>
            <option value="En proceso">En proceso</option>
            <option value="Cerrado">Cerrado</option>
          </select>
        </div>
      </div>

      <div className="border-t border-gray-200 pt-4 mt-2">
        <h5 className="font-bold text-sm text-gray-700 mb-3 flex items-center gap-2">
          <i className="fas fa-tasks text-blue-500"></i> Historial y Sub-estados
        </h5>
        {item.historial && item.historial.length > 0 ? (
          <div className="space-y-2 mb-4">
            {item.historial.map((h, hIdx) => (
              <div
                key={hIdx}
                className="flex justify-between items-start bg-blue-50/50 border border-blue-100 p-3 rounded-lg text-sm group"
              >
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 flex-1">
                  <span className="font-bold text-blue-800 whitespace-nowrap">
                    <i className="far fa-calendar-alt mr-1"></i>
                    {h.fecha}
                  </span>
                  <span className="text-gray-700 break-words">{h.detalle}</span>
                </div>
                <button
                  onClick={() => removeHistorial(hIdx)}
                  className="text-red-400 hover:text-red-600 p-1 px-2 transition-colors"
                  title="Eliminar este sub-estado"
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-xs text-gray-400 italic mb-4 border border-dashed border-gray-300 p-3 rounded-lg text-center">
            No hay un historial de sub-estados registrado aún.
          </p>
        )}
        <div className="flex flex-col sm:flex-row gap-3 items-end bg-gray-50 p-3.5 rounded-lg border border-gray-200 shadow-inner">
          <div className="w-full sm:w-1/4">
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Fecha del estado
            </label>
            <input
              type="date"
              value={newHistorial.fecha}
              onChange={(e) =>
                setNewHistorial({ ...newHistorial, fecha: e.target.value })
              }
              className="w-full text-sm p-2 border border-gray-300 rounded focus:border-blue-500 outline-none"
            />
          </div>
          <div className="w-full sm:flex-1">
            <label className="block text-xs font-semibold text-gray-600 mb-1">
              Descripción / Sub-estado
            </label>
            <input
              type="text"
              placeholder="Ej: Se envió correo al proveedor..."
              value={newHistorial.detalle}
              onChange={(e) =>
                setNewHistorial({ ...newHistorial, detalle: e.target.value })
              }
              className="w-full text-sm p-2 border border-gray-300 rounded focus:border-blue-500 outline-none"
            />
          </div>
          <button
            onClick={addHistorial}
            className="w-full sm:w-auto bg-white border border-blue-600 text-blue-700 hover:bg-blue-50 px-4 py-2 rounded text-sm font-bold transition-colors whitespace-nowrap"
          >
            <i className="fas fa-plus mr-1"></i> Agregar
          </button>
        </div>
      </div>
    </div>
  );
};

export const FormIncidents = (props) => {
  const { procedure } = props;
  const { dialogClose } = useDialog();

  const [loadingSave, setLoadingSave] = useState(false);
  const [perdidas, setPerdidas] = useState([]);
  const [newPerdida, setNewPerdida] = useState({ label: "", description: "" });
  const [reclamos, setReclamos] = useState([]);
  const [newReclamo, setNewReclamo] = useState({
    descripcion: "",
    fechaDeteccion: "",
    quienDetecta: "",
    fechaReclamo: "",
    estado: "Abierto",
    historial: [],
  });

  const { data: fieldsData, loading: loadingFields } = Request({
    urlApi: `/Procedure/${
      procedure.id || procedure.procedureId
    }/datasets?${listFields.map((field) => `fieldnames=${field}`).join("&")}`,
  });

  const { data: incidenciasOptions } = Request({
    urlApi: `/Dropdown/listaIncidencias/options`,
  });

  useEffect(() => {
    if (fieldsData) {
      const pData = fieldsData.find((d) => d.name === "registroDePerdida");
      const rData = fieldsData.find((d) => d.name === "registroDeReclamos");

      /*
      if (pData) {
        const val =
          pData.dataSets?.length > 0 ? pData.dataSets[0].value : pData.initial;
        if (val) {
          try {
            setPerdidas(JSON.parse(val));
          } catch (e) {
            setPerdidas([]);
          }
        }
      }
      */

      if (rData) {
        const val =
          rData.dataSets?.length > 0 ? rData.dataSets[0].value : rData.initial;
        if (val) {
          try {
            const parsed = JSON.parse(val);
            if (Array.isArray(parsed)) {
              const loadedReclamos = parsed.map((r) => {
                if (r.description2 && r.description2.startsWith("{")) {
                  try {
                    return JSON.parse(r.description2);
                  } catch (e) {}
                }
                return {
                  descripcion: r.descripcion || r.label || "",
                  fechaDeteccion: r.fechaDeteccion || r.description3 || "",
                  quienDetecta: r.quienDetecta || "",
                  fechaReclamo: r.fechaReclamo || r.description4 || "",
                  estado: r.estado || r.description5 || "Abierto",
                  historial: r.historial || [],
                };
              });
              setReclamos(loadedReclamos);
            }
          } catch (e) {
            setReclamos([]);
          }
        }
      }
    }
  }, [fieldsData]);

  const handleAddPerdida = () => {
    if (!newPerdida.label && !newPerdida.description) return;
    setPerdidas([...perdidas, newPerdida]);
    setNewPerdida({ label: "", description: "" });
  };
  const removePerdida = (index) =>
    setPerdidas(perdidas.filter((_, i) => i !== index));

  const handleAddReclamo = () => {
    if (!newReclamo.descripcion) {
      toast.warning("La descripción es obligatoria");
      return;
    }
    setReclamos([...reclamos, newReclamo]);
    setNewReclamo({
      descripcion: "",
      fechaDeteccion: "",
      quienDetecta: "",
      fechaReclamo: "",
      estado: "Abierto",
      historial: [],
    });
  };

  const updateReclamo = (index, field, value) => {
    const newR = [...reclamos];
    newR[index][field] = value;
    setReclamos(newR);
  };

  const removeReclamo = (index) =>
    setReclamos(reclamos.filter((_, i) => i !== index));

  const handleSave = async () => {
    setLoadingSave(true);
    try {
      const fieldPerdida = fieldsData.find(
        (d) => d.name === "registroDePerdida",
      );
      const fieldReclamo = fieldsData.find(
        (d) => d.name === "registroDeReclamos",
      );

      const payload = [];
      /*
      if (fieldPerdida) {
        payload.push({
          FieldId: fieldPerdida.id,
          ProcedureId: procedure.id || procedure.procedureId,
          Value: perdidas.length > 0 ? JSON.stringify(perdidas) : "",
          name: fieldPerdida.name,
          type: fieldPerdida.type,
        });
      }
      */
      if (fieldReclamo) {
        const reclamosFormatted = reclamos.map((r) => ({
          label: r.descripcion || "-",
          description: `Det: ${r.fechaDeteccion || "-"} | Rec: ${r.fechaReclamo || "-"} | Est: ${r.estado || "-"}`,
          description2: JSON.stringify(r),
          description3: r.fechaDeteccion || "",
          description4: r.fechaReclamo || "",
          description5: r.estado || "",
        }));

        payload.push({
          FieldId: fieldReclamo.id,
          ProcedureId: procedure.id || procedure.procedureId,
          Value:
            reclamosFormatted.length > 0
              ? JSON.stringify(reclamosFormatted)
              : "",
          name: fieldReclamo.name,
          type: fieldReclamo.type,
        });
      }

      if (payload.length > 0) {
        await requestAuth("post", "/dataset", payload);
      }
      toast.success("Incidentes guardados exitosamente");
      dialogClose();
    } catch (error) {
      console.error(error);
      toast.error("Error al guardar incidentes");
    } finally {
      setLoadingSave(false);
    }
  };

  if (!loadingFields || !fieldsData) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl shadow-xl w-[95vw] max-w-3xl max-h-[90vh] flex flex-col overflow-hidden mx-auto">
      <div className="px-6 py-4 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
        <h2 className="text-xl font-bold text-gray-800">
          Formulario de incidentes
        </h2>
        <button
          onClick={dialogClose}
          className="text-gray-500 hover:text-red-500 text-xl"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="p-6 overflow-y-auto flex-1 space-y-8">
        {/* Registro de Perdida */}
        {/*
        <div>
          <h3 className="text-base font-bold text-gray-700 mb-4 border-b pb-2 flex items-center gap-2">
            <span className="text-green-600">1.</span> Registro de perdida
          </h3>

          <div className="flex flex-col md:flex-row gap-4 items-end mb-4">
            <div className="flex-1 w-full">
              <label className="block text-xs font-semibold text-gray-600 mb-1">
                Lista de campos
              </label>
              <select
                value={newPerdida.label}
                onChange={(e) =>
                  setNewPerdida({ ...newPerdida, label: e.target.value })
                }
                className="w-full border border-gray-300 rounded p-2.5 text-sm outline-none focus:border-blue-500 bg-white"
              >
                <option value="">Seleccionar...</option>
                {incidenciasOptions?.map((opt, i) => (
                  <option key={i} value={opt.name}>
                    {opt.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="flex-1 w-full">
              <label className="block text-xs font-semibold text-gray-600 mb-1">
                Observación
              </label>
              <input
                type="text"
                value={newPerdida.description}
                onChange={(e) =>
                  setNewPerdida({
                    ...newPerdida,
                    description: e.target.value,
                  })
                }
                className="w-full border border-gray-300 rounded p-2.5 text-sm outline-none focus:border-blue-500"
                placeholder="Observación"
              />
            </div>
            <div className="w-full md:w-auto">
              <button
                onClick={handleAddPerdida}
                className="bg-blue-600 text-white px-4 py-2.5 rounded text-sm hover:bg-blue-700 transition w-full"
              >
                Guardar
              </button>
            </div>
          </div>

          <div className="overflow-x-hidden border rounded-lg border-gray-200 shadow-sm">
            <table className="w-full text-sm text-left text-gray-700 table-fixed">
              <thead className="bg-gray-100 font-semibold border-b border-gray-200">
                <tr>
                  <th className="p-3 w-[40%]">Campo</th>
                  <th className="p-3 w-[50%]">Observación</th>
                  <th className="p-3 w-[10%] text-center">Opciones</th>
                </tr>
              </thead>
              <tbody>
                {perdidas.length === 0 ? (
                  <tr>
                    <td
                      colSpan="3"
                      className="p-4 text-center text-gray-500 italic"
                    >
                      La lista esta vacía
                    </td>
                  </tr>
                ) : (
                  perdidas.map((item, idx) => (
                    <tr
                      key={idx}
                      className="border-b border-gray-200 last:border-b-0 hover:bg-gray-50 transition-colors"
                    >
                      <td className="p-3">{item.label}</td>
                      <td className="p-3">{item.description}</td>
                      <td className="p-2 text-center">
                        <button
                          onClick={() => removePerdida(idx)}
                          className="text-red-500 hover:text-red-700 p-1.5 rounded-full hover:bg-red-50 transition-colors"
                          title="Eliminar pérdida"
                        >
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        */}

        {/* Registro de Reclamos */}
        <div>
          <h3 className="text-base font-bold text-gray-700 mb-4 border-b pb-2 flex items-center gap-2">
            <span className="text-green-600">1.</span> Registro de reclamos
          </h3>

          <div className="bg-gray-50 border border-gray-200 p-5 rounded-lg mb-6 shadow-sm">
            <h4 className="text-sm font-bold text-gray-700 mb-4">
              <i className="fas fa-plus-circle text-blue-500 mr-2"></i>Añadir
              nuevo reclamo
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
              <div className="md:col-span-2">
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                  Descripción y causa
                </label>
                <textarea
                  value={newReclamo.descripcion}
                  onChange={(e) =>
                    setNewReclamo({
                      ...newReclamo,
                      descripcion: e.target.value,
                    })
                  }
                  rows="2"
                  className="w-full border border-gray-300 rounded-md p-2.5 text-sm outline-none focus:border-blue-500 bg-white resize-none"
                  placeholder="Describa el problema y la causa..."
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                  Fecha de detección
                </label>
                <input
                  type="date"
                  value={newReclamo.fechaDeteccion}
                  onChange={(e) =>
                    setNewReclamo({
                      ...newReclamo,
                      fechaDeteccion: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 rounded-md p-2.5 text-sm outline-none focus:border-blue-500 bg-white"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                  Quién detectó
                </label>
                <input
                  type="text"
                  value={newReclamo.quienDetecta}
                  onChange={(e) =>
                    setNewReclamo({
                      ...newReclamo,
                      quienDetecta: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 rounded-md p-2.5 text-sm outline-none focus:border-blue-500 bg-white"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                  Fecha de reclamo
                </label>
                <input
                  type="date"
                  value={newReclamo.fechaReclamo}
                  onChange={(e) =>
                    setNewReclamo({
                      ...newReclamo,
                      fechaReclamo: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 rounded-md p-2.5 text-sm outline-none focus:border-blue-500 bg-white"
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                  Estado Global
                </label>
                <select
                  value={newReclamo.estado}
                  onChange={(e) =>
                    setNewReclamo({
                      ...newReclamo,
                      estado: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 rounded-md p-2.5 text-sm outline-none focus:border-blue-500 bg-white"
                >
                  <option value="Abierto">Abierto</option>
                  <option value="En proceso">En proceso</option>
                  <option value="Cerrado">Cerrado</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end pt-3 border-t border-gray-200">
              <button
                onClick={handleAddReclamo}
                className="bg-blue-600 text-white px-5 py-2.5 rounded-md text-sm font-semibold hover:bg-blue-700 transition shadow-sm flex items-center gap-2"
              >
                Añadir a la lista
              </button>
            </div>
          </div>

          <div className="space-y-4">
            {reclamos.length === 0 ? (
              <div className="border border-dashed border-gray-300 rounded-lg p-8 text-center text-gray-500 bg-gray-50">
                La lista de reclamos está vacía
              </div>
            ) : (
              reclamos.map((item, idx) => (
                <ReclamoCard
                  key={idx}
                  item={item}
                  idx={idx}
                  updateReclamo={updateReclamo}
                  removeReclamo={removeReclamo}
                />
              ))
            )}
          </div>
        </div>
      </div>

      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 flex justify-end gap-3">
        <button
          onClick={dialogClose}
          className="px-5 py-2.5 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium shadow-sm"
        >
          Cancelar
        </button>
        <button
          onClick={handleSave}
          disabled={loadingSave}
          className="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium shadow-sm disabled:opacity-50 flex items-center gap-2"
        >
          {loadingSave ? (
            <>
              <i className="fas fa-spinner fa-spin"></i> Guardando...
            </>
          ) : (
            <>
              <i className="fas fa-save"></i> Guardar incidentes
            </>
          )}
        </button>
      </div>
    </div>
  );
};
